/**
 * IM 生成 deck の生成元タスク id から、Web コンソールの指定リソース着地パス（`openConsole` の `next`）を
 * 組み立てる（UC-5・[[2026-07-17 設計ノート slide-studio アドイン指定リソース着地の配線]]）。
 *
 * 生成元が不明（null）なら undefined を返し、呼び出し側は `next` 無しで既定（/home）へ着地させる。
 * 着地先はタスク＝案件・フォーマット・ソース・成果物のハブ。id はクエリ値として安全化する。
 */
export function consoleNextForSourceTask(sourceTaskId: string | null): string | undefined {
    if (!sourceTaskId) return undefined;
    return `/slide-studio?open=task:${encodeURIComponent(sourceTaskId)}`;
}
